import React from "react";
import NoProductsFound from "./NoProductsFound";
import { usePaymentTheme } from "../../respayment/hooks/usePaymentTheme";
import ProductGrid from "../ProductGrid";
import { OrderedProduct, Product } from "src/shared/services/interfacev2";

interface ProductDisplaySectionProps {
  filteredProducts: Product[];
  selectedProducts: OrderedProduct[];
  handleIncrement: (product: Product) => void;
  handleDecrement: (product: Product) => void;
}

const ProductDisplaySection: React.FC<ProductDisplaySectionProps> = ({
  filteredProducts,
  selectedProducts,
  handleIncrement,
  handleDecrement,
}) => {
  const { fontClass } = usePaymentTheme();

  return (
    <>
      {filteredProducts.length > 0 ? (
        <ProductGrid
          products={filteredProducts}
          selectedProducts={selectedProducts}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
        />
      ) : (
        <NoProductsFound fontClass={fontClass} />
      )}
    </>
  );
};

export default ProductDisplaySection;